import Image from "next/image";

export function Logo({ size = 34 }: { size?: number }) {
  return (
    <Image
      src="/logo.webp"
      alt="KinetiRx logo"
      width={size}
      height={size}
      className="shrink-0 rounded-lg"
    />
  );
}
